import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ds';
import { AUTH_BUTTON_STYLE, AuthHeading, AuthLayout } from '@/components/auth/AuthLayout';

const ERROR_MESSAGES: Record<string, string> = {
  TOKEN_EXPIRED: 'This confirmation link has expired. Request a new one to continue.',
  INVALID_TOKEN: 'This confirmation link is invalid. Request a new one to continue.',
  USER_NOT_FOUND: 'We could not find the account linked to this confirmation email.',
};

export function EmailVerificationResultPage() {
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('error');
  const succeeded = searchParams.get('status') === 'success' && !errorCode;

  const continueToApp = () => window.location.assign('/today');
  const tryAgain = () => window.location.assign('/verify-email');

  return (
    <AuthLayout>
      <div className="flex flex-col gap-5">
        <AuthHeading title={succeeded ? 'Email confirmed' : 'We could not confirm your email'}>
          {succeeded
            ? 'Your email address is verified. You can continue setting up your account.'
            : (ERROR_MESSAGES[errorCode ?? ''] ??
              'The confirmation link could not be completed. Please request a new one.')}
        </AuthHeading>

        <Button
          type="button"
          style={AUTH_BUTTON_STYLE}
          onClick={succeeded ? continueToApp : tryAgain}
        >
          {succeeded ? 'Continue' : 'Request a new link'}
        </Button>
      </div>
    </AuthLayout>
  );
}
